import script from "./SiteHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteHeader.vue?vue&type=script&setup=true&lang=js"

import "./SiteHeader.vue?vue&type=style&index=0&id=d1a4d46c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a4d46c"]])

export default __exports__